import configJSON from './config.json';

export default {
  ...configJSON,

  appName: process.env.GATSBY_SITE_NAME,

  app: {
    maxSimultanousConnections: 2,
    trafficSourceUrlParam: 'utm_source',
  },

  siteMetadata: {
    title: process.env.GATSBY_SITE_NAME,
    description: process.env.GATSBY_SITE_DESCRIPTION,
    siteUrl: process.env.GATSBY_SITE_URL,
    keywords: process.env.GATSBY_SITE_KEYWORDS,
    author: process.env.GATSBY_SITE_AUTHOR,
    defaultImage: '/mentorshow-banner',
    fbAppId: process.env.GATSBY_SITE_FB_APP_ID,
  },

  stripeConfig: {
    apiKey: process.env.GATSBY_STRIPE_API_KEY,
  },

  paypalConfig: {
    clientId: process.env.GATSBY_PAYPAL_CLIENT_ID,
  },

  thriveCart: {
    updateInfoUrl: 'https://secure.mentorshow.com/updateinfo/',
  },

  firebaseConfig: {
    apiKey: process.env.GATSBY_FIREBASE_API_KEY,
    authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.GATSBY_FIREBASE_DATABASE_URL,
    projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
    storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  },

  parseServer: {
    serverUrl: process.env.GATSBY_PARSE_SERVER_URL,
    mountPoint: process.env.GATSBY_PARSE_MOUNT_POINT,
    apiUrl: `${process.env.GATSBY_PARSE_SERVER_URL}/api`,
  },

  presence: {
    url: process.env.GATSBY_PRESENCE_SERVER_URL,
  },

  routePaths: {
    landingPage: '/',
    classPage: '/cours/:slug',
    classLesson: '/programme/:classSlug/lessons/:lessonSlug',
    classProgram: '/programme/:classSlug',
    signin: '/auth/signin',
    signinRoute: '/auth/signin/*',
    signup: '/auth/signup',
    signupRoute: '/auth/signup/*',
    signupClass: '/auth/signup/class',
    signupClassRoute: '/auth/signup/class',
    signupPass: '/auth/signup/pass',
    signupPassRoute: '/auth/signup/pass',
    signupGift: '/auth/signup/gift',
    signupGiftRoute: '/auth/signup/gift',
    passwordForget: '/auth/password-forget',
    passwordForgetRoute: '/auth/password-forget',
    passwordReset: '/auth/password',
    passwordResetRoute: '/auth/password',
    passwordConfirm: '/auth/password-confirm',
    passwordConfirmRoute: '/auth/password-confirm',
    getPass: '/auth/checkout/pass',
    getPassRoute: '/auth/checkout/pass',
    getSingle: '/auth/get-single',
    getSingleRoute: '/auth/get-single',
    getClass: '/auth/checkout/class',
    getClassRoute: '/auth/checkout/class',
    getGift: '/auth/checkout/gift',
    getGiftRoute: '/auth/checkout/gift',
    confirm: '/auth/confirm',
    confirmRoute: '/auth/confirm',
    homepage: '/app',
    settings: '/settings',
    dashboard: '/dashboard',
    dashboardRoute: '/dashboard',
    myClasses: '/dashboard/my-classes',
    myClassesRoute: '/dashboard/my-classes',
    program: '/programme',
    classes: '/cours',
    allClasses: '/classes',
    classLanding: '/cours/:slug',
    terms: '/static/:slug',
    pass: '/pass-illimite',
    webinarSignup: '/webinar/signup',
    webinarSignin: '/webinar/signin',
    referralInvite: '/guest-invite',
    gift1year: '/checkout/offrir-1-an-pass-illimite',
  },
};
